export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-200">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="rounded-2xl bg-background-50 p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
              随时随地
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
              移动观影
            </h2>
            <p className="text-sm text-foreground-500 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
              6080新视觉影院完美适配手机与平板设备，无需下载APP，打开浏览器即可畅享高清影视。支持横竖屏切换、手势调节亮度和音量，通勤路上、午休时间，随时随地追剧看片。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors duration-200"
              >
                <i className="ri-smartphone-line text-base"></i>
                手机端体验
              </a>
              <a
                href="#features"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#features')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg border border-foreground-200 text-foreground-600 font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-background-100 transition-colors duration-200"
              >
                了解更多功能
              </a>
            </div>
          </div>

          <div className="flex-shrink-0">
            <div className="relative w-48 md:w-56 aspect-[9/16] rounded-2xl overflow-hidden shadow-lg bg-background-900">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20screen%20mockup%20displaying%20a%20clean%20movie%20streaming%20interface%20with%20movie%20posters%20grid%2C%20dark%20theme%20with%20warm%20golden%20accents%2C%20minimal%20UI%20design%2C%20cinematic%20atmosphere%2C%20no%20text%20on%20UI&width=600&height=1067&seq=app-mobile-01&orientation=portrait"
                alt="6080新视觉影院移动端体验"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}